module.exports = __webpack_public_path__ + "img/map-wangarra.6ead4139.webp";